import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { SignalElementConfiguration } from "@domain/project/configurations/signal-element-configuration";
import { FgdsProject } from "@domain/project/fgds-project";
import { Floorplan } from "@domain/project/floorplan/floorplan";
import { ConfiguredProductComponent } from "@project/floorplanner/floorplan-menu/fgds/configured-product/configured-product.component";
import { FloorplanProductMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-product-menu/floorplan-product-menu.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-signal-menu",
  templateUrl: "./floorplan-signal-menu.component.html",
  styleUrls: ["./floorplan-signal-menu.component.scss"],
  imports: [UiKitModule, FloorplanProductMenuComponent, ConfiguredProductComponent],
})
export class FloorplanSignalMenuComponent {
  private floorplanService = inject(FloorplanService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplan: Floorplan;

  protected readonly tooltipTextSignalElements: string = $localize`:@@global.signalElements:Leuchttransparente`;

  constructor() {
    this.floorplan = this.floorplanService.selectedFloorplan;
  }

  protected get signalElements(): readonly SignalElementConfiguration[] {
    if (this.floorplan.project instanceof FgdsProject) {
      return this.floorplan.project.signalElements;
    }
    return [];
  }

  protected addSignalElement(signalElement: SignalElementConfiguration) {
    this.floorplanService.addSignalElement(signalElement);
  }

  protected addPlaceholder() {
    this.floorplanService.addSignalElementPlaceholder();
  }

  deleteSignalElement(signalElement: SignalElementConfiguration) {
    (this.floorplan.project as FgdsProject).deleteSignalElement(signalElement);
  }

  drag(signalElementConfig: SignalElementConfiguration) {
    this.dragDropService.setDragged({ type: DraggedItemType.SIGNAL_ELEMENT, config: signalElementConfig });
  }

  dragPlaceholder() {
    this.dragDropService.setDragged({ type: DraggedItemType.SIGNAL_ELEMENT_PLACEHOLDER });
  }

  protected updateSignalElementsItemTextVisibility(visible: boolean) {
    this.floorplan.floorplanState.updateSignalElementsItemTextVisibility(visible);
  }
}
